import { axiosInstance } from '@libs/axios/axios';
import { CreateImportPayment, Payment } from '../subscription/entity';
import { UserForm } from './entity';
import { apiCall, Invoice } from '@shared/entity';

export type UserOverviewPayment = {
  id: string;
  refId: string;
  transactionId: string;
  amount: string;
  currency: string;
  status: 'PENDING' | 'PAID' | 'CANCELLED' | 'AUTHORIZED';
  createdAt: string;
  subscriptionId: string | null;
};

export type UserOverview = {
  userId: string;
  name: string;
  email: string;
  appStartDate: string;
  subscriptionPlan: string | null;
  subscriptionStatus: 'ACTIVE' | 'CANCELLED' | 'EXPIRED' | 'PENDING' | null;
  subscriptionStartDate: string | null;
  subscriptionEndDate: string | null;
  nextPaymentDate: string | null;
  lastPaymentStatus: 'PENDING' | 'PAID' | 'CANCELLED' | 'AUTHORIZED' | null;
  payments: UserOverviewPayment[];
  lastLog: { message: string; createdAt: string } | null;
};

export const importPaymentApi = {
  get: () => 'api/payment',
  create: () => 'api/payment/import',
};

export const postCreateImportPayment = async (
  params: CreateImportPayment,
): Promise<{
  code: number;
  message: string;
  transId: string;
  redirect: string;
}> =>
  apiCall(
    async () => await axiosInstance.post(importPaymentApi.create(), params),
    'api.profile.paymentCreateError',
  );

export const getPayment = async (): Promise<Payment> =>
  apiCall(
    async () => await axiosInstance.get(importPaymentApi.get()),
    'api.profile.paymentDetailsError',
  );

//---- Invoices ----

export const invoiceApi = {
  getAll: () => 'api/invoices',
};

export const getInvoices = async (): Promise<Invoice[]> =>
  apiCall(async () => await axiosInstance.get(invoiceApi.getAll()), 'api.profile.invoicesNotFound');

export const userApi = {
  get: () => '/api/users',
  getOverview: () => '/api/users/overview',
  getLogs: (userId: string) => `/api/logs?userId=${encodeURIComponent(userId)}`,
  getAllLogs: () => '/api/logs/',
  deleteUser: () => '/api/users',
};

export const updateUserData = async (userData: UserForm): Promise<UserForm> =>
  apiCall(async () => await axiosInstance.put(userApi.get(), userData), 'api.profile.updateError');

export const uploadUserAvatar = async (imageData: string): Promise<UserForm> =>
  apiCall(
    async () => await axiosInstance.put('/api/users/avatar', { imageData }),
    'api.profile.updateError',
  );

export const markNewsSeen = async (): Promise<UserForm> =>
  apiCall(async () => await axiosInstance.patch('/api/users/seen-news'), 'api.profile.updateError');

export const deleteUser = async (): Promise<{ deletionScheduledAt: string }> =>
  apiCall(async () => await axiosInstance.delete(userApi.deleteUser()), 'api.profile.deleteError');

export const getUser = async (): Promise<UserForm> =>
  apiCall(async () => await axiosInstance.get(userApi.get()), 'api.profile.userNotFound');

export const getUsersOverview = async (): Promise<UserOverview[]> =>
  apiCall(
    async () => await axiosInstance.get(userApi.getOverview()),
    'api.profile.usersOverviewError',
  );
